var map = {
	"./ADA.png": "a134",
	"./ATM.png": "211a",
	"./BCH.png": "a71c",
	"./BTC.png": "2930",
	"./BTG.png": "e483",
	"./CHZ.png": "13ec",
	"./DOGE.png": "9542",
	"./EOS.png": "b4ff",
	"./ETC.png": "c7e8",
	"./ETH.png": "debf",
	"./FIL.png": "3b82",
	"./HT.png": "a3a0",
	"./JUV.png": "93bf",
	"./KSM.png": "7268",
	"./LINK.png": "6251",
	"./LTC.png": "bb74",
	"./PSG.png": "1e63",
	"./SOC.png": "c87b",
	"./TRX.png": "b1ef",
	"./UNI.png": "c6c5",
	"./XAUT.png": "d991",
	"./XRP.png": "132b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3a4";